const TaskIcons = {
  single_choice: "🎯",
  write_in: "📝",
  numeric: "🔢",
  user_choice: "👤",
  task_write_in_choice: "📊",
};

export default TaskIcons;
